<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height container-background" fluid></v-container>
            <v-container 
                class="fill-height justify-center" 
                fluid

            >
                <v-row 
                    align="center" 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col cols="12">
                        <v-expand-transition>
                            <v-card 
                                width="400"
                                v-show="expand"
                                class="elevation-12 mx-auto pa-4"
                            >                            
                                <v-row
                                    justify="center"
                                >
                                    <v-img
                                        src="../../assets/logo.png"
                                        max-width="70"
                                        contain
                                        class="d-flex"
                                    ></v-img>
                                </v-row>
                                <v-row no-gutters> 
                                    <v-col cols="12">
                                        <div class="pa-4">
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                v-if="getloginErrors"
                                                class="red--text"
                                            >
                                                {{ getloginErrors }}
                                            </v-alert>    
                                        </div>                                       
                                        
                                        <div class="text-center font-weight-light primary--text">Welcome to</div>
                                        <div class="text-h4 text-sm-h5 font-weight-black text-center primary--text">{{ schoolName }}</div>        
                                        <v-card-text>
                                            <div class="primary--text text-h5 text-center">Student Portal</div>                                            
                                        </v-card-text>

                                        <v-alert
                                            dense
                                            outlined
                                            type="error"
                                            v-if="errorMessage"
                                        >
                                            {{ errorMessage }}
                                        </v-alert>

                                        <v-form 
                                            class="pa-5"
                                            @submit.prevent
                                        >
                                            <v-text-field
                                                label="Student ID"
                                                name="id"                                                
                                                type="text"
                                                color="primary"
                                                v-model="formData.student_id"
                                                clearable
                                                autofocus
                                                v-on:keyup="keyPressId"  
                                                outlined
                                                dense
                                                hide-details                                                       
                                            >
                                            </v-text-field>
                                            
                                            <v-row class="">
                                                <v-col cols="5" class="d-flex align-center py-6">
                                                    <v-divider></v-divider>
                                                </v-col>
                                                <v-col cols="2" class="d-flex align-center px-0 py-0 justify-center text-caption grey--text">
                                                    OR
                                                </v-col>
                                                <v-col cols="5" class="d-flex align-center py-0">
                                                    <v-divider></v-divider>
                                                </v-col>
                                            </v-row>

                                            <v-text-field
                                                label="Birth Certificate Pin"
                                                name="id"                                                
                                                type="text"
                                                color="primary"
                                                v-model="formData.birth_certificate_pin"
                                                clearable
                                                autofocus
                                                v-on:keyup="keyPressId"  
                                                outlined
                                                dense                                                       
                                            >
                                            </v-text-field> 

                                            <div class="py-5"></div>

                                            <v-menu
                                                ref="menuDateOfBirth"
                                                v-model="menuDateOfBirth"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="auto"
                                                
                                            >
                                                <template v-slot:activator="{ on, attrs}">
                                                    <v-text-field
                                                        v-model="dateOfBirthFormatted"
                                                        label="Date of Birth"
                                                        hint="YYYY/MM/DD"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @blur="dateOfBirth = parseDate(dateOfBirthFormatted)"
                                                        :rules="[rules.required]"
                                                        outlined
                                                        dense
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    ref="picker"
                                                    v-model="formData.date_of_birth"
                                                    :active-picker.sync="activePicker"
                                                    :max="new Date().toISOString().substr(0, 10)"
                                                    min="1950-01-01"
                                                    @input="menuDateOfBirth = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        
                                    
                                            <div class="text-right mt-6">                                                
                                                <v-btn 
                                                    color="primary" 
                                                    @click="submit" 
                                                    dark
                                                    block
                                                >LOGIN</v-btn>
                                            </div>                                               
                                
                                            
                                        </v-form>
                                    </v-col>                                
                                </v-row>
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>
                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
            </v-container>            
        </v-main>        
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        //
    },
    data(){
        return {            
            show: false,
            userpassword: '',
            formData: {
                student_id: '',
                password: '',
                birth_certificate_pin: null,
                date_of_birth: null
            },
            password: true,
            expand: true,
            menuDateOfBirth: false,
            activePicker: null,
            dateOfBirth: null,
            rules: {
                required: value => !!value || 'Required.',
            },
            errorMessage: '',                      
        }
    },         
    props: {
        source: String,
    },
    watch: {
        userpassword: {
            handler(val){
                this.formData.student_id = val;                
            }
        },
        
        menuDateOfBirth (val) {
            if(val){
                this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            }
        },
        
    },
    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'auth/getSchoolName',
            getloginErrors: 'auth/getLoginErrors',
            authenticated: 'auth/getAuthenticated',
            getResetPassword: 'auth/getResetPassword',
            admin: 'auth/getAdmin',
            validStudentID: 'auth/getStudentIDValidation',            
            passwordHint: 'auth/getPasswordHint',
            passwordPlaceholder: 'auth/getPasswordPlaceholder',
            user: 'auth/getUser',            
        }),

        dateOfBirthFormatted () {
            if(!this.formData.date_of_birth) return null;
            const [year, month, day] = this.formData.date_of_birth.split('-');
            return `${year}/${month}/${day}`;
        }
        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            changePassword: 'auth/changePassword',            
            getUser: 'auth/getUser',
        }),

        ...mapMutations({
            openDialog: 'auth/setDialog',
            setNewPassword: 'auth/setNewPassword',
            setUser: 'auth/setUser',
            setStep: 'auth/setStep',            
        }),

        async submit () {
            if(!this.formData.student_id && !this.formData.birth_certificate_pin){
                this.errorMessage = 'Enter Student ID or Birth Certificate PIN';
                return;
            }

            if(!this.formData.date_of_birth){
                this.errorMessage = 'Enter Date of Birth';
                return;
            }
            
            this.errorMessage = '';
            let user = Object.assign({}, this.user); 
            user.student_id = this.formData.student_id;
            user.birth_certificate_pin = this.formData.birth_certificate_pin;
            const [year, month, day] = this.formData.date_of_birth.split('-');
            user.password = `${year}${month}${day}`;
            
            // console.log('User: ', user);

            this.setUser(user);           
            console.log('Authenticating..');
            await this.signIn(user);
            console.log(`Authenticated: ${this.authenticated}`)                       
            if(this.authenticated){
                this.setStep(1);
                this.$router.replace('/dashboard');
            }
            else{
                this.loginErrors = this.getLoginErrors 
            }                     
        },       

        keyPressId (e) {
            if(e.keyCode === 13){
                this.$refs.password.focus();
            }
        },

        keyPressPassword (e) {            
            if(e.keyCode === 13){
                this.submit();
            }
        },

        parseDate (date) {
            if(!date) return null;
            const [day, month, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
        
    }
}
</script>

<style scoped>
    .container-background{
        background-image: url('../../assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }    

</style>